import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { HOCPHANBOSUNG_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import moment from 'moment';
import { trangThaiHocBoSungValue } from '../../../../utils/define';

const schema = yup.object().shape({
    tenHocPhan: yup.string().required('Vui lòng nhập tên học phần')
});

const HocPhanBoSungEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                tenHocPhan: dataEdit.tenHocPhan || '',
                ngayBatDau: dataEdit.ngayBatDau ? moment(dataEdit.ngayBatDau).format('YYYY-MM-DD') : '',
                soHocPhan: dataEdit.soHocPhan !== null && dataEdit.soHocPhan !== undefined ? dataEdit.soHocPhan : '',
                diemSo: dataEdit.diemSo !== null && dataEdit.diemSo !== undefined ? dataEdit.diemSo : '',
                fileCongVan: dataEdit.fileCongVan || '',
                fileKetQua: dataEdit.fileKetQua || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${HOCPHANBOSUNG_API.UPDATE_ITEM}/${dataEdit.id}`, null, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            TenHocPhan: values.tenHocPhan,
            NgayBatDau: values.ngayBatDau || null,
            SoHocPhan: values.soHocPhan ? Number(values.soHocPhan) : null,
            DiemSo: values.diemSo ? Number(values.diemSo) : null,
            FileCongVan: values.fileCongVan || '',
            FileKetQua: values.fileKetQua || '',
            TrangThai: dataEdit.trangThai || trangThaiHocBoSungValue.chuaHoc
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['hocPhanBoSungData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    if (!initialValues) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Học phần bổ sung</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={initialValues}
                    enableReinitialize
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenHocPhan"
                                            value={values.tenHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.tenHocPhan && !!errors.tenHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày bắt đầu</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayBatDau"
                                            value={values.ngayBatDau}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Số học phần/Tín chỉ</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="soHocPhan"
                                            value={values.soHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Điểm số</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="diemSo"
                                            value={values.diemSo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File công văn"
                                            value={values.fileCongVan}
                                            onChangeProp={(url) => setFieldValue('fileCongVan', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File kết quả"
                                            value={values.fileKetQua}
                                            onChangeProp={(url) => setFieldValue('fileKetQua', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Đang lưu...</> : <><i className="fas fa-save mr-1"></i> Cập nhật</>}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default HocPhanBoSungEdit;
